import { render, staticRenderFns } from "./SettingLayout.vue?vue&type=template&id=5bb52876"
import script from "./SettingLayout.vue?vue&type=script&lang=js"
export * from "./SettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports